import {
  EmailReport,
  EmailReportCreateRequest,
  EmailReportUpdateRequest,
} from '../../types/app/emailReport.types';
import { api } from '../core/api';

export const getEmailReportList = () =>
  api.get<EmailReport[]>('EmailReport/GetList').then((res) => res.data);

export const getEmailReport = (id: number) =>
  api.get<EmailReport>(`EmailReport/GetItem/?id=${id}`).then((res) => res.data);

export const getTimeZones = () =>
  api.get<string[]>(`EmailReport/GetTimeZones`).then((res) => res.data);

export const getDefaultTimeZone = () =>
  api.get<string>(`EmailReport/GetDefaultTimeZone`).then((res) => res.data);

export const updateEmailReport = (data: EmailReportUpdateRequest) =>
  api.put(`EmailReport/UpdateItem`, data).then((res) => res.data);

export const createEmailReport = (data: EmailReportCreateRequest) =>
  api.post(`EmailReport/CreateItem`, data).then((res) => res.data);

export const deleteEmailReport = (id: number) =>
  api.delete<EmailReport>(`EmailReport/DeleteItem/?id=${id}`).then();

export const markAsSent = (id: number) =>
  api.put(`EmailReport/MarkAsSent?id=${id}`).then((res) => res.data);
export const unMarkAsSent = (id: number) =>
  api.put(`EmailReport/UnMarkAsSent?id=${id}`).then((res) => res.data);
